import type { CSSProperties } from 'react';
import { EDR_COLORS } from './edrTokens';

/** Display value for API `hostName` (OS hostname) as Endpoint Label. */
export const formatEndpointLabel = (hostName?: string | null): string => {
  const trimmed = typeof hostName === 'string' ? hostName.trim() : '';
  return trimmed || 'N/A';
};

/** Read `hostName` from a loose API/row object. */
export const readHostName = (item: {
  hostName?: string | null;
} | null | undefined): string | undefined => {
  if (!item || typeof item.hostName !== 'string') return undefined;
  const trimmed = item.hostName.trim();
  return trimmed || undefined;
};

/** Blue link style for Endpoint column when the row can open endpoint details. */
export const edrEndpointNameLinkStyle = (canOpen: boolean): CSSProperties => ({
  fontWeight: 600,
  color: canOpen ? EDR_COLORS.brand600 : EDR_COLORS.textPrimary,
  cursor: canOpen ? 'pointer' : 'default',
});
